import { Component, Input, Output, EventEmitter, SimpleChanges, TemplateRef } from '@angular/core';
import * as Highcharts from 'highcharts';
// import HC_histogram from 'highcharts/modules/histogram-bellcurve';
// HC_histogram(Highcharts);
@Component({
  selector: 'app-graph-slider',
  templateUrl: './graph-slider.component.html',
  styleUrls: ['./graph-slider.component.scss']
})
export class GraphSliderComponent {
  updateFlag= false;

  Highcharts: typeof Highcharts = Highcharts;
  @Input() xSeries: Array<number>;
  @Input() ySeries: Array<number>;
  @Input() min: number;
  @Input() max: number;
  @Input() step: number;
  @Input() selectedMin: number;
  @Input() selectedMax: number;
  @Input() label: string;
  @Input() magnitude: string;
  @Input() currency: string;
  @Input() amountFormatter: TemplateRef<any>;

  @Output() onSelectionChange: EventEmitter<any> = new EventEmitter();
  chartOptions: Highcharts.Options
  // this.xSeries = [102539.28213831666, 205078.56427663332, 307617.84641495004, 410157.12855326664, 512696.4106915833, 615235.6928299001, 717774.9749682167, 820314.2571065333, 922853.5392448499, 1025392.8213831666, 1127932.1035214835, 1230471.3856598001, 1333010.6677981168, 1435549.9499364335, 1538089.23207475, 1640628.5142130665, 1743167.7963513832, 1845707.0784896999, 1948246.3606280165, 2050785.6427663332];
  // this.ySeries = [7, 10, 3, 1, 1, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1];
  // this.min = 102539;
  // this.max = 2050786;
  // this.selectedMin = 300000;
  // this.selectedMax = 600000;


  ngOnChanges(changes: SimpleChanges) {
    if(changes.xSeries.currentValue || changes.ySeries.currentValue
      || changes.selectedMax.currentValue || changes.selectedMin.currentValue) {
      if (
        this.xSeries &&
        this.ySeries &&
        (this.selectedMax !== undefined && this.selectedMax !== null) &&
        (this.selectedMin !== undefined && this.selectedMin !== null)
      ) {
        this.chartOptions = {
          chart: {
            type: 'column',
            height: 150,
            // width: 100
          },
          legend: {enabled: false},
          xAxis: {
            labels: {
              enabled: false
            },
            plotBands: [{
                from: this.xSeries[0] -2,
                to: this.selectedMin,
                color: '#E6E8EB'
            }, {
                from: this.selectedMax,
                to: this.xSeries[this.xSeries.length-1] +1,
                color: '#E6E8EB'
            }
          ],
            // categories: this.filteredX
            // categories: this.xSeries.map((val) => val.toString())
          },
          yAxis: {
            visible: false,
            min: 0,
            startOnTick: false
          },
          series: [{
            type: 'column',
            // color: '#168384',
            // data: this.filteredY,
            data: this.xSeries.map((x, i) => [x, this.ySeries[i]]),
            name: 'No. of Drugs'
          }],
          plotOptions: {
              series: {
                  zoneAxis: "x",
                  zones: [{
                      value: this.selectedMin,
                      color: '#E6E8EB'
                  }, {
                      value: this.selectedMax,
                      color: '#168384'
                  }, {
                      color: '#E6E8EB'
                  }],
                  threshold: -10
              }
          },
        }
      }
    }
    
  }

  onMinValueChange(valueObj) {
    console.log("min value changed to :", valueObj);
    this.selectedMin = valueObj && valueObj.value;
    // this.emitMinMaxValues();
  }

  onMaxValueChange(valueObj) {
    console.log("max value changed to :", valueObj);
    this.selectedMax = valueObj && valueObj.value;
    // this.emitMinMaxValues();
  }

  updateChart(min, max) {
    let options = this.Highcharts.getOptions();
    this.chartOptions.plotOptions.series.zones = [{
          value: min,
          color: '#E6E8EB'
      }, {
          value: max,
          color: '#168384'
      }, {
          color: '#E6E8EB'
      }];
      
    (this.chartOptions.xAxis as any).plotBands = [{
          // from: this.xSeries[0],
          from: this.min,
          to: min,
          color: '#E6E8EB'
      }, {
          from: max,
          // to: this.xSeries[this.xSeries.length-1] +1,
          to: this.max,
          color: '#E6E8EB'
      }
    ]
    this.updateFlag = true;
  }

  onMinMaxChange(obj) {
    let {min, max} = obj;
    this.selectedMin = min;
    this.selectedMax = max;
    console.log("selectedMin value: ", min);
    console.log("selectedMax value: ", max);
    setTimeout(() => {this.updateChart(this.selectedMin, this.selectedMax)}, 0);
    this.onSelectionChange.emit({min, max});
  }

  onInstantMinMaxChange(obj) {
    console.log(obj);
    this.updateChart(obj.min, obj.max);
  }
}
